/*
 * @Author: xieyu7 
 * @Date: 2019-04-01 15:43:46 
 * @Last Modified by: hanjin
 * @Last Modified time: 2022-08-19 17:18:00
 */
import request from '../utils/service'
const api = {
  getLoginStates:function(data) {
    return request({
      url:'/driver/v2/api/loginStates',
      method: 'get',
      params: data
    })
  },
  getAds:function(data) {
    return request({
      url:'/publicity/v2/api/advertisings',
      method: 'get',
      params: data
    })
  },
  getNearByParks(data) {
    return request({
      url: '/dealer/v2/api/nearbyParks',
      method: 'get',
      params: data
    })
  },
  /* 获取包期规则列表 */
  getBagRuleList(params) {
    return request({
      url: '/special/v2/api/bagMultiRules',
      method: 'get',
      params
    })
  },
  getIndexInfo:function() {
    return request({
      url: '/api/v1/hasRegisteredBerth',
      method: 'post',
      data: {
        thirdId: localStorage.getItem('openId')
      }
    })
  },
  searchPark:function(data) {
    return request({
      url: '/dealer/v2/api/parksByName',
      method: 'get',
      params: data
    })
  },
  getUserLockList:function() {
    return request({
      url: '/api/v1/getUserLockList',
      method: 'post',
      data: {
        thirdId: localStorage.getItem('openId')
      }
    })
  },
  getBagableParksByLocation:function(data) {
    return request({
      // url: '/dealer/v2/api/nearbyParksPro', 废弃
      url: '/dealer/v2/api/nearbyBagParks',
      method: 'get',
      params: data
    })
  },
  getUserSigned:function(data) {
    return request({
      url: '/driver/v2/api/getDriverIdByThirdId',
      method: 'get',
      params: data
    })
  },
  checkIntegral(){
    return request({
      url: '/special/v2/api/diffTimeBook/isAllow',
      method: 'get',
    })
  },
  homeFuncEntries(params){
    return request({
      url: '/basic/v2/api/homeFuncEntries',
      method: 'get',
      params
    })
  },
  allFuncEntries(params){
    return request({
      url: '/basic/v2/api/allFuncEntries',
      method: 'get',
      params
    })
  },
  saveHomeFuncEntries(data){
    return request({
      url: '/basic/v2/api/homeFuncEntries/save',
      method: 'post',
      data
    })
  }
}

export default api